import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'job'

export default function JobPage() {
  const submit = useSubmit()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value || undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const jobTitle = formData.get('job') as string
    if (!jobTitle) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your job?",
      answer_key: jobTitle.toLowerCase(),
      answer: jobTitle,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  const handleSkip = () => {
    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your job?",
      answer_key: 'skipped',
      answer: 'Skipped',
    }

    const formData = new FormData()
    formData.append('job', 'skipped')
    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <TextInputPage
      heading="pages.onboarding.job.heading"
      placeholder="pages.onboarding.job.placeholder"
      onSubmit={handleSubmit}
      onSkip={handleSkip}
      showSkipButton={true}
      inputName="job"
      value={preselectedValue}
    />
  )
}
